export default __webpack_public_path__ + "static/media/Adrish1.3103a709.png";